import { defineComponent as _defineComponent } from 'vue'
import { isDefined } from '@sh/helpers';
import { IconsV2 } from '@sh/types/General';
import { computed } from 'vue';
import icons from './iconsV2';

interface Props {
  type: IconsV2;
  height?: number;
  fill?: boolean;
  styles?: Record<string, string>;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'OptimizerIconV2.ts',
  props: {
    type: null,
    height: null,
    fill: { type: Boolean },
    styles: null
  },
  emits: ['click'],
  setup(__props: any, { emit: emits }) {

const props = __props as {
  type: IconsV2;
  height?: number;
  fill?: boolean;
  styles?: Record<string, string>;
};





const icon = computed(() => icons[props.type]);

const style = computed(() => ({
  ...(isDefined(props.height) && { height: `${props.height}px` }),
  ...(isDefined(props.height) && { width: `${props.height}px` }),
  ...(props.styles && { ...props.styles }),
}));

return { __sfc: true,emits, props, icon, style }
}

})